module.exports = __webpack_public_path__ + "img/3.178dffb0.jpg";